import '.bx{position:absolute;}.ssr-plugin'
import '.fj{left:1rem;}.ssr-plugin'
import '.fk{top:50%;}.ssr-plugin'
import '.fl{transform:translateY(-50%);}.ssr-plugin'
import '.e1{z-index:1;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.fm{flex-shrink:1;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.fn{max-height:calc(100vh - 10rem);}.ssr-plugin'
import '.fo{right:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { ReactNode } from 'react'
import { IconButton } from '@app/components/core/button/IconButton'
import {
  faArrowRight,
  faArrowLeft,
  faImages,
} from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@app/components/core/button/Button'
import { Image } from '@app/components/core/image/Image'
import useMediaQuery from '@app/util/useMediaQuery'

export type ImageDisplayProps = {
  displayedImage: string
  displayedImageAlt?: string
  overviewButtonLabel: string
  header: ReactNode
  canGoBack: boolean
  canGoForwad: boolean
  goBack: () => void
  goForward: () => void
  goToOverview?: () => void
}

export const ImageDisplay = ({
  displayedImage,
  displayedImageAlt = '',
  overviewButtonLabel,
  header,
  canGoBack,
  canGoForwad,
  goBack,
  goForward,
  goToOverview,
}: ImageDisplayProps) => {
  const isMobile = useMediaQuery()

  return (
    <Row
      style={{
        alignItems: 'stretch',
        width: '100%',
        padding: '2rem',
        maxHeight: '100vh',
        position: 'relative',
      }}
    >
      {canGoBack && (
        <div className="bx fj fk fl e1"
        >
          <IconButton icon={faArrowLeft} onClick={goBack} />
        </div>
      )}
      <Column
        style={{
          alignItems: 'stretch',
          minWidth: 0,
          width: '100%',
          padding: isMobile ? '0' : '0 4rem',
        }}
      >
        <Column
          alignItems="stretch"
          style={{
            justifyContent: 'space-between',
          }}
        >
          {header}
          <div className="a fm ax t n fn"
          >
            <Image
              src={displayedImage}
              alt={displayedImageAlt}
              resizeWidth={isMobile ? 800 : 1920}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                display: 'block',
                borderRadius: '1.25rem',
              }}
            />
          </div>
          {goToOverview && (
            <Button
              variant="secondary"
              label={overviewButtonLabel}
              icon={faImages}
              iconPosition="left"
              onClick={goToOverview}
              style={{ alignSelf: 'end' }}
            />
          )}
        </Column>
      </Column>
      {canGoForwad && (
        <div className="bx fo fk fl e1"
        >
          <IconButton icon={faArrowRight} onClick={goForward} />
        </div>
      )}
    </Row>
  )
}
